import { render, staticRenderFns } from "./MonederoCRUD.vue?vue&type=template&id=d3dd5cf4"
import script from "./MonederoCRUD.vue?vue&type=script&lang=js"
export * from "./MonederoCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports